import { api } from 'utility';
import {
  getSubsetServiceUrl,
  getSubsetBranchUrl,
  getStatesUrl,
  getCitiesUrl,
  getToggleBranchStatusUrl,
  getAddressExportFileUrl,
  getBusinessFinancialInfoServiceUrl,
  getReportBillForOtherUrl,
  getDetaileFinancialReportImprestUrl,
  getUploadBusinessInfoDocumentUrl,
  getExportBillForOtherUrl,
  getCRTagAccountUrl, updateSubSet,
  getlastTransactionForOtherUrl,
} from "URLs";
class SubsetServices {
  getSubsets(params) {
    return api.get(getSubsetServiceUrl(), { params });
  }

  addSubset(data) {
    return api.post(getSubsetServiceUrl(), data);
  }

  addBranch(data) {
    return api.post(getSubsetBranchUrl(), data);
  }

  updateSubSetBranch(data) {
    return api.put(updateSubSet(), data);
  }
  updateBranch(data) {
    return api.put(getSubsetBranchUrl(), data);
  }

  getBranch(params) {
    return api.get(getSubsetBranchUrl(), { params }).then((res) => res.data);
  }

  getStates() {
    return api.get(getStatesUrl()).then((res) => res.data);
  }

  getCities(params) {
    return api.get(getCitiesUrl(), { params }).then((res) => res.data);
  }

  changeStateOfBranch(data) {
    return api.put(getToggleBranchStatusUrl(), data);
  }

  getBusinessfinancialInfo(data) {
    return api.get(getBusinessFinancialInfoServiceUrl(data.branchId)).then((res) => res.data);
  }
  changeBusinessfinancialInfo(id, data) {
    return api.post(getBusinessFinancialInfoServiceUrl(id), data);
  }

  getBranchTransction(userId, params, data) {
    return api.post(getReportBillForOtherUrl(userId), data, { params });
  }
  getSummaryReportBranch(businessId, data, params) {
    return api
      .post(getDetaileFinancialReportImprestUrl(businessId), data, { params })
      .then((res) => res.data);
  }

  getUploadFile(userId, documentItemId, params) {
    return api
      .get(getUploadBusinessInfoDocumentUrl(userId, documentItemId), { params })
      .then((res) => res.data);
  }
  reportPdf(data, params, userId) {
    return api.post(getExportBillForOtherUrl(userId), data, { params }).then((res) => res.data);
  }
  getAddressExportFile() {
    return api.get(getAddressExportFileUrl()).then((res) => res.data);
  }
  /**
   * لیست برچسب ها
   */
  getListTag(params) {
    return api.get(getCRTagAccountUrl(), { params }).then((res) => res.data);
  }
  /**
   * دریافت بازه زمانی فیلتر از سرویس 
   */
  reportGetDateFromServer(params) {
    return api.get(getlastTransactionForOtherUrl(), { params }).then((res) => res.data);
  }
}

export default new SubsetServices();
